import type { PagesProjects } from '~/types';
import { getNavItemUrl } from './navigation';

export function getPortfolioTourLink(page?: PagesProjects) {
  const item = page?.virtual_tour_navigation;
  const preview = page?.is_virtual_tour_preview === true;
  if (!page?.virtual_tour_intro?.trim() || !item || typeof item !== 'object') return null;
  if (!preview && item.status !== 'published') return null;
  const href = getNavItemUrl(item);
  if (!href || !item.title) return null;

  if (preview && href.startsWith('/') && !href.startsWith('//')) {
    const target = new URL(href, 'https://preview.invalid');
    target.searchParams.set('preview', 'true');
    return { label: item.title, href: target.pathname + target.search + target.hash };
  }

  return { label: item.title, href };
}
